import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificacionHistorialService {
  readonly refreshListado = new BehaviorSubject<boolean>(false);

  notifyRefreshListado(): void {
    this.refreshListado.next(true);
  }
}
